/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Stitch Web
 * OpenAPI spec version: 0.0.53
 */

export type PhysicianSpecialty =
	(typeof PhysicianSpecialty)[keyof typeof PhysicianSpecialty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PhysicianSpecialty = {
	Addiction_Medicine: 'Addiction Medicine',
	'Allergy_&_Immunology': 'Allergy & Immunology',
	Audiology: 'Audiology',
	Bariatrics_Surgery: 'Bariatrics Surgery',
	Cardiology: 'Cardiology',
	Chiropractic: 'Chiropractic',
	Colorectal_Surgery: 'Colorectal Surgery',
	Dentistry: 'Dentistry',
	Dermatology: 'Dermatology',
	Emergency_Medicine: 'Emergency Medicine',
	Endocrinology: 'Endocrinology',
	Family_Medicine: 'Family Medicine',
	Gastroenterology: 'Gastroenterology',
	General_Surgery: 'General Surgery',
	Geriatrics: 'Geriatrics',
	Gynecology: 'Gynecology',
	'Hematology_&_Oncology': 'Hematology & Oncology',
	Hormone_Replacement_Therapy: 'Hormone Replacement Therapy',
	Hospice_and_Palliative_Care: 'Hospice and Palliative Care',
	Infectious_disease: 'Infectious disease',
	'Inpatient-based_Specialties': 'Inpatient-based Specialties',
	Internal_Medicine: 'Internal Medicine',
	IV_Therapy: 'IV Therapy',
	'Lifestyle/Integrative/Functional_Medicine':
		'Lifestyle/Integrative/Functional Medicine',
	'Medical_Spas/Aesthetics': 'Medical Spas/Aesthetics',
	Medical_Weight_loss: 'Medical Weight loss',
	Naturopathy: 'Naturopathy',
	Nephrology: 'Nephrology',
	Neurology: 'Neurology',
	Neurosurgery: 'Neurosurgery',
	'Obstetrics_&_Gynecology': 'Obstetrics & Gynecology',
	Occupational_Medicine: 'Occupational Medicine',
	Occupational_Therapy: 'Occupational Therapy',
	Ophthalmology: 'Ophthalmology',
	Optometry: 'Optometry',
	Orthopedics: 'Orthopedics',
	'Otolaryngology_(ENT)': 'Otolaryngology (ENT)',
	'Pain_Medicine/Anesthesiology': 'Pain Medicine/Anesthesiology',
	Pediatrics: 'Pediatrics',
	Physical_Therapy: 'Physical Therapy',
	Plastic_surgery: 'Plastic surgery',
	Podiatry: 'Podiatry',
	Psychiatry: 'Psychiatry',
	'Psychology/Mental_and_Behavioral_Health':
		'Psychology/Mental and Behavioral Health',
	Pulmonology: 'Pulmonology',
	Radiology: 'Radiology',
	Rheumatology: 'Rheumatology',
	Sleep_medicine: 'Sleep medicine',
	Sports_medicine: 'Sports medicine',
	Unknown: 'Unknown',
	Urgent_Care: 'Urgent Care',
	Urology: 'Urology',
	Vascular_Surgery: 'Vascular Surgery',
	Wound_Care: 'Wound Care',
} as const;
